/* eslint-disable jira/filename-case */
import type { WebResourceResponse } from '@jira/global-pages__dashboard-common/src/types.tsx';

const generateScriptTags = (response: WebResourceResponse): string => {
	let resourceHtml = `
        <script type="text/javascript" data-defer-skip>
            window.WRM=window.WRM||{};window.WRM._unparsedData=window.WRM._unparsedData||{};window.WRM._unparsedErrors=window.WRM._unparsedErrors||{};
            WRM._unparsedData = Object.assign({}, WRM._unparsedData, JSON.parse(${JSON.stringify(
							JSON.stringify(response.unparsedData),
						)}));
            WRM._unparsedErrors = Object.assign({}, WRM._unparsedErrors, JSON.parse(${JSON.stringify(
							JSON.stringify(response.unparsedErrors),
						)}));
            if(window.WRM._dataArrived)window.WRM._dataArrived();
        </script>
    `;
	response.resources.forEach((resource) => {
		const { url, resourceType, key } = resource;

		if (resourceType === 'CSS') {
			const cssResource = `<link
                href=${url}
                type="text/css"
                rel="stylesheet"
                media="all"
                data-wrm-key=${key}
                data-wrm-batch-type="context"
            />`;
			resourceHtml += cssResource;
		} else {
			const jsResource = `<div>
                <script
                    type="text/javascript"
                    data-initially-rendered
                    data-defer-skip
                    src=${url}
                    data-wrm-key=${key}
                    data-wrm-batch-type="context"
                ></script>
            </div>`;
			resourceHtml += jsResource;
		}
	});

	return resourceHtml;
};

export default generateScriptTags;
